import React, { useState } from 'react'
import {Button,Modal} from 'react-bootstrap'
import {Tabs,Tab} from 'react-bootstrap'


const style = {
    "buttonSpace":{
        "margin-top": '10px',
        "margin-right": '10px'
    }
}

function ModalPersyaratan () {
    
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <div style={style.buttonSpace}>
            <Button variant="outline-primary" onClick={handleShow} >
                Persyaratan Peserta & Mekanisme
            </Button>

            <Modal show={show} onHide={handleClose} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Persyaratan Peserta</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <Tabs defaultActiveKey="kriteria" className="nav-justified">
                    <Tab eventKey="kriteria" title="Kriteria">
                        <br/>
                        <h6>
                            Peserta merupakan sebuah tim yang terdiri dari maksimal 3 (tiga) orang anggota. Setiap anggota dari tim wajib memenuhi syarat sebagai berikut:
                        </h6>
                        <p>1. Warga Negara Indonesia (WNI).</p>
                        <p>2. Pelajar atau Profesional.</p>
                        <p>3. Memiliki kartu identitas diri yang masih berlaku (Kartu Pelajar/KTP/SIM/Paspor). Kartu identitas terdaftar wajib disertakan pada saat verifikasi pemenang.</p>

                    </Tab>
                    <Tab eventKey="mekanisme" title="Mekanisme">
                    <br/>
                    <p>1. Informasi mengenai aktivitas Digital Construction Hack akan disampaikan melalui website.</p>
                    <p>2. Peserta diharuskan mengirimkan minimal 1 (satu) ide atau lebih dari 1 (satu) ide berisi seputar sistem aplikasi konstruksi yang bisa memudahkan serta nyaman digunakan masyarakat Indonesia.</p>
                    <p>3. Peserta mengusulkan ide aplikasi dalam platform apapun. Boleh menggunakan sumber data terbuka jika dibutuhkan.</p>
                    <p>4. Ide yang diusulkan harus informatif, user-friendly, tidak mengandung unsur pornografi, pornoaksi, SARA, maupun politik.</p>
                    <p>5. Peserta melakukan pendaftaran dengan mengisi formulir untuk isian identitas diri, kemampuan pemrograman, ide yang ingin dikembangkan, dan nama anggota tim.</p>
                    <p>6. Dengan mendaftar ide ke Digital Construction Hack, setiap peserta menjamin bahwa ide tersebut adalah hasil karya asli, tanpa melanggar hak kekayaan intelektual atau hak lain dari pihak ketiga.</p>


                    </Tab>
                    <Tab eventKey="submisiIde" title="Submisi Ide">
                        <br/>
                        <p>1. Periode pendaftaran submisi ide berlangsung dari 25 September sampai dengan 31 Oktober 2019.</p>
                        <p>2. Tim yang terpilih akan diumumkan di website dch.ptpp.co.id pada tanggal 1-10 November 2019.</p>
                    </Tab>
                </Tabs>
                </Modal.Body>
                {/* <Modal.Footer></Modal.Footer> */}
            </Modal>
        </div>
    );
}


export default ModalPersyaratan
